import Scopes from "./Scopes";

export default Scopes;
